import SummaryPrice from 'components/summary/SummaryPrice/container';

export default SummaryPrice;
